const CACHE_PREFIX = 'vf_cache_';
const DEFAULT_TTL = 5 * 60 * 1000; // 5 minutes

export const getCached = (key) => {
  if (typeof window === 'undefined') return null;
  
  try {
    const raw = sessionStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    
    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > DEFAULT_TTL) {
      sessionStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return data;
  } catch (e) {
    console.error('[Cache] Error reading:', key, e);
    return null;
  }
};

export const setCached = (key, data) => {
  if (typeof window === 'undefined') return;
  
  try {
    sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({
      data,
      timestamp: Date.now()
    }));
  } catch (e) {
    console.error('[Cache] Error writing:', key, e);
  }
};

export const clearCache = (key) => {
  if (typeof window === 'undefined') return;
  
  if (key) {
    sessionStorage.removeItem(CACHE_PREFIX + key);
  } else {
    // Clear all vf caches
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(CACHE_PREFIX))
      .forEach(k => sessionStorage.removeItem(k));
  }
};

export const clearAllCaches = () => {
  clearCache(null);
};

export { DEFAULT_TTL, CACHE_PREFIX };